export default {
    fund: [{
            "title": "关于我国开放式基金赎回，以下说法错误的是（　　）。",
            "question": "A．采取金额赎回的方式\nB．可以采取未知价法\nC．采取份额赎回的方式\nD．T日的赎回申请通常在T+1日确认",
            "answer": "A",
            "explain": "我国开放式基金，含股票基金、债券基金、货币市场基金等，其中（1）股票基金、债券基金，采取未知价交易、金额申购、份额赎回的原则，T日的赎回申请通常在T+1日确认。（2）货币市场基金，采取确定价、金额申购、份额赎回原则，货币市场基金申购和赎回基金份额价格以1元人民币为基准进行计算，货币市场基金申购以金额申请，赎回以份额申请。"
        },
        {
            "title": "关于证券投资基金在金融体系中的地位与作用，以下表述错误的是（　　）。",
            "question": "A．汇集众多小额资金组合投资，降低了直接融资比例\nB．作为直接投资工具，能够有效分流储蓄资金\nC．倡导理性的投资文化，有助于防止市场的过度投机\nD．为投资者提供了有效参与证券市场的投资渠道",
            "answer": "B",
            "explain": "证券投资基金是一种面向中小投资者设计的间接投资工具，这是针对于投资者的角度来讲的；相对应的，基金和股票是直接融资工具，这是针对于融资者的角度来讲的。所以，这样直接融资的比例就降低了。证券投资基金发挥专业理财优势，推动市场价值判断体系的形成，倡导理性的投资文化，有助于防止市场的过度投机。"
        },
        {
            "title": "关于违法失信信息，以下表述正确的是（　　）。",
            "question": "A．违法失信信息在诚信档案中的效力期限为5年\nB．超过效力期限的违法失信信息，不再进行诚信信息公开，但继续接受诚信信息申请查询\nC．因证券期货违法行为被市场禁入的信息效力期限为15年\nD．违法失信信息的效力期限自对违法失信行为的处理决定执行完毕之日起算",
            "answer": "D",
            "explain": "《证券期货市场诚信监督管理办法》第十三条规定，违法失信信息在诚信档案中的效力期限为3年，“5年”说法错误，但因证券期货违法行为被行政处罚、市场禁入、刑事处罚和判决承担较大侵权、违约民事赔偿责任的信息，其效力期限为5年，“15年”说法错误；前款所规定的效力期限，自对违法失信行为的处理决定执行完毕之日起算。超过效力期限的违法失信信息，不再进行诚信信息公开，并不再接受诚信信息申请查询。"
        },
        {
            "title": "关于对冲基金，以下表述正确的是（　　）。",
            "question": "A．对冲基金意为“风险对冲过的基金”，其投资风险低于传统的证券投资基金\nB．对冲基金一般以公募基金为主要方式\nC．对冲基金一般广泛投资于金融衍生品\nD．对冲基金起源于20世纪50年代的英国金融市场",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于基金管理公司风险管理的全面性原则，以下表述错误的是（　　）。",
            "question": "A．风险管理必须覆盖公司除风险管理职能部门以外的所有部门\nB．风险管理必须贯穿于所有业务流程和业务环节\nC．风险管理是公司经营管理和业务运作体系中不可或缺的因素\nD．风险管理必须涵盖所有风险类型",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某货币基金T日总份额为100亿份，T+1日接受申购3亿份，赎回15亿份，基金转换转出1亿份，转入4亿份，以下说法正确的是（　　）。",
            "question": "A．T+1日触发巨额赎回，管理人认为兑付全部赎回有困难，可以拒绝金额较大的赎回申请\nB．T+1日未触发巨额赎回，管理人需接受全额赎回\nC．T+1日触发巨额赎回，管理人认为有能力兑付全部赎回申请时，可以接受全额赎回\nD．T+1日触发巨额赎回，管理人认为兑付全部赎回有困难，可以暂停赎回",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "中国证监会检查人员先后多次前往某上市公司检查，该公司及相关人员拒收检查通知书、阻碍检查人员进入办公场所、不肯接受询问。中国证监会拟根据有关规定，对该公司给予警告并处以罚款，并对主要责任人员采取10年证券市场禁入措施。该上市公司及相关人员的行为属于（　　）。",
            "question": "A．涉嫌证券期货犯罪\nB．拒不配合中国证监会及其派出机构监督检查、调查\nC．违法开展经营活动\nD．涉嫌证券期货违法",
            "answer": "B",
            "explain": ""
        }, {
            "title": "假设某投资者在某ETF基金募集期内认购了100万份ETF，基金份额折算日的基金资产净值为320亿元，折算前基金份额总额为310亿份，当日标的指数收盘值为966.45元，则该投资者折算后的份额为（　　）。",
            "question": "A．120.8万份\nB．110.5万份\nC．105.6万份\nD．106.8万份",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "道德实现其约束力主要依靠的手段不包括（　　）。",
            "question": "A．社会舆论\nB．内心信念\nC．国家强制力\nD．传统习俗",
            "answer": "C",
            "explain": "道德是一种社会意识形态，依靠社会舆论、传统习俗和内心信念等约束力呈，实现调整人与人之间、人与社会之间关系的行为规范的总和。法律主要依靠国家强制力保证实施。故本题选C。"
        },
        {
            "title": "某基金管理人拟聘请某影视明星在视频网站对公募证券投资基金进行推荐。对于此种做法，以下表述正确的是（　　）。",
            "question": "A．此类推荐违反法规规定，属于禁止性行为\nB．广告内容可以采用“祝贺基金净值又创新高”的措辞\nC．对基金进行推荐的主体，必须是监管机构或行业协会指定的机构或个人\nD．对基金进行推荐的主体，必须是基金的真实持有人",
            "answer": "A",
            "explain": "基金宣传推介材料必须真实、准确，与基金合同、基金招募说明书相符，不得登载单位或者个人的推荐性文字。故本题选A。"
        },
        {
            "title": "以下不属于基金与保险的差异的是（　　）。",
            "question": "A．对投资人要求不同\nB．目的不同\nC．性质不同\nD．变现能力不同",
            "answer": "C",
            "explain": "基金与保险产品的差异为：目的不同；投资人要求不同；变现能力不同。基金是一种投资工具，投资基金的目的是获得投资收益；而保险的主要功能是保障，它是一种具有保障功能的理财工具，意义在于分散或者转移风险。"
        },
        {
            "title": "按照基金从业人员职业道德中的守法合规要求，基金机构应当做到（　　）。",
            "questions": "I．完善内部各项规章制度<br>II．强化工作流程管理<br>III．形成守法合规企业文化<br>IV．及时将新出台法规告知基金从业人员",
            "question": "A．III、IV\nB．I、II、III、IV\nC．I、III、IV\nD．I、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金投资人风险承受能力调查和评价，以下表述正确的是（　　）。",
            "questions": "I．基金销售机构应对首次购买基金产品的基金投资人进行风险承受能力调查和评价，对已购买基金的投资人不必做追溯调查<br>II．基金销售机构可以采用当面、信函、网络，或对已有客户信息进行分析等方式对基金投资人的风险承受能力进行调查<br>III．基金销售机构应当针对不同的基金投资人制定不同的风险承受能力调查问卷进行调查和评价<br>IV．基金销售机构应当定期或不定期地更新对基金投资人的风险承受能力评价结果",
            "question": "A．II、IV\nB．II、III\nC．I、III\nD．I、II",
            "answer": "A",
            "explain": "基金销售机构应当在基金投资人首次开立基金交易账户时或首次购买基金产品前对基金投资人的风险承受能力进行调查和评价；对已经购买了基金产品的基金投资人，基金销售机构也应当追溯调查，评价该基金投资人的风险承受能力，基金销售机构可以采用当面、信函、网络"
        },
        {
            "title": "私募基金可以通过以下哪种方式进行宣传（　　）。",
            "question": "A．对通过特定对象确定程序的客户推送产品说明\nB．管理人官网\nC．海报、户外广告\nD．公开出版资料",
            "answer": "A",
            "explain": "私募基金可以对通过特定对象确定程序的客户推送产品说明进行宣传。其他选项属于公募基金宣传材料的范围。"
        }, {
            "title": "在以下各项中，属于公募基金发售前所必须公开披露的文件包括（　　）。",
            "questions": "I．基金获准注册批文<br>II．基金托管协议<br>III．基金招募说明书<br>IV．基金管理人上年度年报摘要",
            "question": "A．II、III、IV\nB．I、II、III\nC．II、III\nD．I、III、IV",
            "answer": "C",
            "explain": "公募基金产品发售前通常会公布四大主要法律文件，基金合同、基金托管协议、基金招募说明书和基金份额发售公告。"
        },
        {
            "title": "关于私募基金风险揭示书中所涉及的风险中，以下属于私募基金特殊风险的是（　　）。",
            "question": "A．基金未托管所涉风险\nB．流动性风险\nC．募集失败风险\nD．资金损失风险",
            "answer": "A",
            "explain": "私募基金的特殊风险，包括基金合同与中国基金业协会合同指引不一致所涉风险、基金未托管所涉风险、基金委托募集所涉风险、外包事项所涉风险、聘请投资顾问所涉风险、未在中国基金业协会登记备案的风险等。私募基金的一般风险，包括资金损失风险、基金运营风险、流动性风险、募集失败风险、投资标的的风险、税收风险等。"
        },
        {
            "title": "以下人员中，需要取得基金从业资格的有（　　）。",
            "questions": "I．证券公司总部从事基金宣传推介活动的人员<br>II．证券公司营业网点从事基金宣传推介活动的人员<br>III．证券投资咨询机构营业网点从事基金理财业务咨询活动的人员<br>IV．商业银行营业网点从事基金理财业务咨询活动的人员",
            "question": "A．I\nB．IV\nC．I、II、IV\nD．I、II、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "债券发行人的信用质量下降导致债券价格下跌的风险属于（　　）。",
            "question": "A．市场风险\nB．操作风险\nC．流动性风险\nD．信用风险",
            "answer": "D",
            "explain": "信用风险是指由于债券发行人出现拒绝支付利息或到期时拒绝支付本息，或由于债券发行人信用质量降低导致债券价格下跌，以及因交易对手违约而产生的风险。"
        },
        {
            "title": "关于基金从业人员职业道德中保守秘密的基本要求，以下表述正确的是（　　）。",
            "questions": "I．基金从业人员应当妥善保管并严格保守客户秘密，非经许可不得泄露客户资料和交易信息<br>II．基金从业人员在任期内应当妥善保管并严格保守客户秘密，离职后则无继续保守秘密的义务<br>III．基金从业人员不得泄露在执业活动中所获知的各相关方的信息及所属机构的商业秘密，更不得用以为自己或他人谋取不正当的利益<br>IV．基金从业人员不得泄露在执业过程中获得的内幕信息",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "B",
            "explain": "基金从业人员应当做到以下几点：（1）应当妥善保管并严格保守客户秘密，非经许可不得泄露客户资料和交易信息。且无论是在任职期间还是离职后，均不得泄露任何客户资料和交易信息；"
        },
        {
            "title": "基金管理公司内部控制的目标是（　　）。",
            "questions": "I．实现股东的投资回报<br>II．保证公司经营运作符合法律和行业监管规则的规定<br>III．为投资人取得正收益<br>IV．确保经营业务的稳健运行和受托资产的安全完整",
            "question": "A．II、III\nB．II、IV\nC．I、III\nD．III、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "关于QDII基金的特点，以下表述错误的是（　　）。",
            "question": "A．QDII基金可以人民币、美元或者其他主要外汇货币为计价货币募集\nB．QDII基金与境内证券市场的相关性较低\nC．QDII基金的管理人须有合格境内机构投资者的资格\nD．QDII基金可以在境外募集资金进行境内证券投资",
            "answer": "D",
            "explain": "QDII基金是指在一国境内设立，经该国有关部门批准从事境外证券市场的股票、债券等有价证券投资的基金。“可以在境外募集资金进行境内证券投资”说法错误。"
        },
        {
            "title": "关于基金管理公司管理层下设的风险管理委员会的职责，以下表述错误的是（　　）。",
            "question": "A．重点关注内控机制薄弱环节和可能给公司带来重大损失的事件，提出控制措施和解决方案\nB．指导、协调和监督各职能部门和各业务部门开展风险管理工作\nC．每日监控风险敞口，对风险管理决策和风险管理制度执行情况进行日常检查、评估和报告\nD．制定相关风险控制政策，审批风险管理重要流程和风险敞口管理体系",
            "answer": "C",
            "explain": "风险管理委员会对管理层负责，协助管理层履行以下职责：（1）指导、协调和监督各职能部门和各业务单元开展风险管理工作；制订相关风险控制政策，审批风险管理重要流程和风险敞口管理体系，并与公司整体业务发展战略和风险承受能力相一致；"
        },
        {
            "title": "关于基金管理人管理的证券投资基金财产的说明，以下表述错误的是（　　）。",
            "question": "A．基金管理人依法解散进行清算时，基金财产作为其清算财产\nB．法律、行政法规禁止流通的财产，不可能是基金财产\nC．基金持有人死亡或者依法解散、被依法撤销、被宣告破产时，基金财产作为其遗产或者是清算财产\nD．基金管理人因基金财产的管理运用、处分而取得的财产，应归入基金财产",
            "answer": "A",
            "explain": "根据我国《证券投资基金法》的规定，基金财产的独立性表现在：（1）基金财产的债务由基金财产本身承担，基金份额持有人以其出资为限对基金财产的债务承担责任。（2）基金财产独立于基金管理人、基金托管人的固有财产。基金管理人、基金托管人因依法解散、被依法撤销或者被依法宣告破产等原因进行清算的，基金财产不属于其清算财产。故“基金管理人依法解散进行清算时，基金财产作为其清算财产”错误。"
        },
        {
            "title": "以下行为符合基金公司独立运作原则的是（　　）。",
            "question": "A．某基金管理公司的董事长同时担任其股东单位的投资部总经理\nB．某基金管理公司的大股东不满意现任基金公司总经理的工作能力，在没有经过该基金公司董事会批准时\nC．某基金管理公司大股东要求该基金公司聘任会计主管时要征得股东同意\nD．某基金管理公司的投资总监在其股东单位担任兼职投资顾问，股东单位不支付薪酬",
            "answer": "A",
            "explain": "独立性原则要求基金管理人各机构、部门和岗位职责应当保持相对独立。基金资产、自有资产、其他资产的运作应当分离。基金管理公司及其业务部门与股东、实际控制人及其下属部门之间没有隶属关系；股东及其实际控制人不得越过股东会和董事会直接任免基金管理公司高管人员；不得违反公司章程干预投资、研究、交易等具体事务及公司员工选聘；董事、监事之外的所有员工不得在股东单位兼职；所有与股东签"
        },
        {
            "title": "公募基金销售人员的以下行为中，不符合基金销售人员行为规范的是（　　）。",
            "question": "A．当所在机构的利益与某机构投资者利益发生冲突时，确保所在机构利益优先\nB．分发的基金宣传推介材料为基金管理公司统一制作的材料\nC．向投资者推介基金时出示身份证明及基金从业资格证明\nD．积极为投资者提供售后服务，解答投资者的疑问",
            "answer": "A",
            "explain": "基金销售人员行为规范之一为客户至上，是指基金从业人员的执业活动应一切从投资人的根本利益出发，其基本含义：（1）客户利益优先；（2）公平对待客户。客户利益优先要求基金从业人员必须全心全意地忠实于客户，依客户利益行事，当发生利益冲突时，将客户的利益置于个人及所在机构的"
        },
        {
            "title": "在基金管理人合规工作中起到纲领性、指导性作用并对基金管理人开展合规工作提出了原则性要求的是（　　）。",
            "question": "A．合规政策\nB．合规文化\nC．合规责任\nD．公司章程",
            "answer": "A",
            "explain": "合规政策是基金管理人体现合规理念、培育合规文化、实现合规目标的纲领性、指导性的文件，对基金管理人开展合规工作提出了原则性要求。"
        }, {
            "title": "私募基金募集机构通过互联网媒介在线向投资者推介私募基金，应当设置的特定对象确认程序包括（　　）。",
            "questions": "I．投资者如实填报真实身份信息及联系方式<br>II．募集机构通过验证码等方式核实用户的注册信息<br>III．投资者在线填报风险识别能力和风险承担能力的问卷调查",
            "question": "A．II、III\nB．I、II\nC．I、III\nD．I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于证券投资基金的特点，以下表述正确的包括（　　）。",
            "questions": "I．将资金交给基金管理人管理，使中小投资者能够享受到专业化的投资管理服务<br>II．证券投资基金实行基金投资人和基金管理人利益共享、风险共担的原则<br>III．组合投资、分散风险是基金的特色<br>IV．严格监管与信息透明是公募基金的显著特点",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于公募基金净值公告，以下表述错误的是（　　）。【常考】",
            "question": "A．普通基金的净值公告内容包括基金资产净值、份额净值、份额累计净值等信息\nB．开放式基金在开放申购赎回之前需至少每月公告一次净值\nC．封闭式基金需至少每周公告一次净值\nD．货币市场基金的收益公告内容包括每万份基金净值收益和最近7日年化收益率",
            "answer": "B",
            "explain": "（1）普通基金净值公告主要包括基金资产净值、份额净值和份额累计净值等信息。封闭式基金和开放式基金在披露净值公告的频率上有所不同。"
        },
        {
            "title": "关于基金销售渠道的审慎调查，以下表述正确的是（　　）。",
            "questions": "I．基金代销机构应对基金管理人进行审慎调查<br>II．基金管理人应对基金代销机构进行审慎调查<br>III．基金投资人应对基金代销机构进行审慎调查",
            "question": "A．I、III\nB．I、II、III\nC．II、III\nD．I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "某公募基金拟于2019年7月11日（周四）公开发售，该公募基金的基金管理公司最晚应于（　　）在指定网站上公布基金招募说明书、基金合同、基金托管协议、基金份额发售公告、基金产品资料概要。",
            "question": "A．2019年7月7日\nB．2019年7月8日\nC．2019年7月9日\nD．2019年7月10日",
            "answer": "B",
            "explain": "基金份额的发售，由基金管理人负责办理。基金管理人应当在基金份额发售的3日前公布招募说明书、基金合同及其他有关文件。题干表明2019年7月11日（周四）发售，往前推3天就是公布相关文件的时间，故选“2019年7月8日”。"
        },
        {
            "title": "某基金销售有限公司（以下简称该公司）主要依托互联网进行基金销售，该公司基金网于2017年12月10日推出一项名为“十全十美”的年终客户大回馈活动，活动持续10天。活动期间，凡是在该公司基金网参加“十全十美”活动并将活动信息分享给好友的，即可获得相应数量货币基金份额。证监会派出机构对其进行现场检查时，发现以下事实：\nI．该活动收益率由货基收益及分享奖励两部分组成，分享奖励由该公司自行补贴\nII．将货基收益和分享奖励加，投资者参加活动的投资收益类别最高档可达到10%\nIII．宣传资料显示：“业绩稳健，欲购从速”：“可安心享受成长”\nIV．在宣传资料刊登10个工作日后，该公司将宣传资料发送至中国证监会派出机构进行备案\n鉴于上述行为，不属于证监会派出机构可以对该公司采取的行政监管处罚措施的是（　　）。",
            "question": "A．责令对该批次宣传推介材料进行整改\nB．永久取消该公司基金销售业务资格\nC．责令该公司限期改正\nD．对相关高管及工作人员出具警示函",
            "answer": "B",
            "explain": ""
        }, {
            "title": "关于投资股票、基金、债券的收益与风险大小，以下表述错误的是（　　）。",
            "question": "A．基金投资是组合投资\nB．债券能为投资人带来利息收入\nC．基金投资收益率高于股票\nD．股票价格波动较大",
            "answer": "C",
            "explain": "基金投资收益率不一定大于股票，两者不具有可比性。股票价格在每一交易日内始终处于变动之中；股票基金净值的计算每天只进行1次，因此每一交易日股票基金只有1个价格，故“基金投资收益率高于股票”错误。基金属于集合理财方式，进行多元化投资，故“基金投资是组合投资”正确；债券一般均需要发行人到期还本付息，故“债券能为投资人带来利息收入”正确。"
        },
        {
            "title": "在基金公司、基金公司股东、基金公司员工、基金份额持有人之间的利益发生冲突时，应当优先保障（　　）的利益。",
            "question": "A．基金公司股东\nB．基金公司\nC．基金公司员工\nD．基金份额持有人",
            "answer": "D",
            "explain": "中国证监会《证券投资基金行业高级管理人员任职管理办法》(2004)规定，高级管理人员、基金管理公司基金经理应当维护所管理基金的合法利益，在基金份额持有人的利益与基金管理公司、基金托管银行的利益发生冲突时，应当坚持基金份额持有人利益优先的原则；不得从事或者配合他人从事损害基金份额持有人利益的活动。"
        },
        {
            "title": "某券商为取得基金托管资格的基金托管人，拟按基金合同召开基金份额持有人大会，下列做法正确的是（　　）。",
            "questions": "I．提前20日公告大会的召开时间、会议形式、审议事项、议事程序和表决方式等事项<br>II．提前30日公告大会的召开时间、会议形式、审议事项、议事程序和表决方式等事项<br>III．会议召开后，将持有人大会决定的事项报中国证监会核准或备案并予以公告<br>IV．会议召开后，将持有人大会决定的事项报中国证券投资基金业协会核准或备案并予以公告",
            "question": "A．II、III\nB．II、IV\nC．I、III\nD．I、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "扰乱市场正常秩序，侵害投资者合法权益的严重违法行为包括（　　）。",
            "questions": "I．虚假记载<br>II．误导性陈述<br>III．重大遗漏",
            "question": "A．I、II、III\nB．I、II\nC．II、III\nD．I、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于基金销售机构对普通投资者需要承担的特别责任和要求，以下表述正确的是（　　）。",
            "questions": "I．应对普通投资者进行细化分类管理<br>II．不得主动推介超越投资者风险承受能力的产品<br>III．举证责任倒置原则<br>IV．禁止普通投资者转化为专业投资者",
            "question": "A．I、II、III、IV\nB．I、III、IV\nC．I、II、IV\nD．I、II、III",
            "answer": "D",
            "explain": "普通投资者在信息告知、风险警示、适当性匹配等方面享有特别保护。基金销售机构对普通投资者应做到以下方面："
        },
        {
            "title": "以下投资者中不符合专业投资者条件的是（　　）。",
            "question": "A．某企业（最近1年净资产1000万元且以自有资金进行超过5年的证券投资）\nB．某慈善基金\nC．某人寿保险公司\nD．某自然人（金融资产500万元且具有3年证券投资经验）",
            "answer": "A",
            "explain": "符合以下条件之一的为专业投资者："
        }, {
            "title": "关于基金销售的后端收费模式，下列描述错误的是（　　）。",
            "question": "A．基金管理人可以根据客户申购金额的数量适用不同的后端申购费率标准\nB．对于持有期低于3年的投资人，基金管理人不得免收其后端申购费用\nC．后端收费方式是指在赎回时从赎回金额中扣除认购费或申购手续费的方式\nD．基金管理人可以根据客户持有期限适用不同的后端申购费率标准",
            "answer": "A",
            "explain": "基金管理人会针对不同类型的开放式基金、不同认购金额等设置不同的认购费率。在基金份额认购上存在两种收费模式：（1）前端收费模式是指在认购基金份额时就支付认购费用的付费模式，基金管理人可以选择根据投资人申购金额分段设置申购费率；"
        },
        {
            "title": "关于合规管理的协调性原则的内涵，以下表述正确的是（　　）。",
            "question": "A．是指合规管理人员应处理好与公司各部门的关系，避免不必要的内耗\nB．是指合规管理人员应规范适当的内部核查标准，并保证统一标准进行风险评估报告\nC．是指合规管理人员应熟悉业务制度，了解业务流程，准确把握法律法规的规定和监管动态\nD．是指合规管理人员应协调相关部门对违规事实进行客观评价，避免出现合规人员与业务人员合谋违规",
            "answer": "A",
            "explain": "协调性原则是指合规人员应当正确处理与公司其他部门及监管部门的关系，努力形成公司的合规合力，避免内部消耗。公正性原则是指合规人员在对业务部门进行核查时，应当坚持统一标准来对违规行为风险进行评估和报告。专业性原则是指合规人员应当熟悉业务制度，了解基金管理人各种业务的运作流程，并准确理解和把握法律法规的规定和变动趋势。客观性原则是指合规人员应当依照相关法规对违规事实进行客观评价，避免出现合规人员自身与业务人员合谋的违规行为。"
        },
        {
            "title": "非跨境的ETF，其交易日的基金份额净值将通过证券交易所行情发布系统于（　　）揭示。",
            "question": "A．下1个节假日前\nB．次2个交易日\nC．当日\nD．次1个交易日",
            "answer": "D",
            "explain": "交易日的基金份额净值除了按规定于次日（跨境ETF可以为次2个工作日）在指定报刊和管理人网站披露外，也将通过证券交易所的行情发布系统于次1个交易日（跨境ETF可以为次2个工作日）揭示。"
        },
        {
            "title": "从业人员甲从基金管理公司离职时，带走了公司的客户清单，将这些客户清单交给新就职的基金管理公司用来拓展客户，甲的行为（　　）。",
            "questions": "I．违反了忠诚尽责的职业道德规范<br>II．违反了保守秘密的职业道德规范<br>III．违反了专业审慎的职业道德规范<br>IV．是一种不正当竞争行为",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II、IV\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "根据《证券投资基金管理公司管理办法》和《基金管理公司子公司管理规定》，公募证券投资基金管理公司可以设立专业子公司经营（　　）。",
            "question": "A．投资顾问业务\nB．特定客户资产管理业务\nC．公募基金管理业务\nD．基金托管业务",
            "answer": "B",
            "explain": "基金管理公司可以设立子公司从事特定客户资产管理业务、私募股权基金管理业务以及中国证监会许可的其他业务。"
        },
        {
            "title": "某基金公司进行组织结构调整，让投资研究部的人员甲在公司合规风控部兼任投资业务的合规工作，并由研究部总监考核。以下（　　）项是对于该分工调整的正确评价。",
            "question": "A．该分工调整可以提高合规风控人员的工作积极性，有利于增强团队稳定\nB．该分工调整有利于合规风控人员提高专业性，改善工作质量\nC．该分工调整有利于信息透明，提高合规风控人员的工作效率\nD．该分工调整违反了合规风控工作的独立性要求，不能真正起到牵制制约的作用",
            "answer": "D",
            "explain": "基金公司通过公司章程、公司制度、部门制度和岗位职责等方式明确各部门、各岗位、各员工的具体职责，通过这些职责的规定明确公司对员工的授权，以此做到授权的清晰化和固定化。"
        }, {
            "title": "关于公募基金年度报告，以下表述正确的是（　　）。",
            "question": "A．基金年度报告应当在每年结束之日起60日内编制完成并公告\nB．基金年度报告须经1/2以上独立董事签字同意，并由董事长签发\nC．基金年度报告登载在指定网站上，年度报告提示性公告登载在指定报刊上\nD．基金年度报告应披露近5年每年的基金收益分配情况",
            "answer": "C",
            "explain": "基金定期报告包括基金季度报告、基金半年度报告和基金年度报告。"
        },
        {
            "title": "通过汇集多数投资者的资金直接或间接投资于私募基金，需要进行穿透调查最终投资者是否为合格投资者的是（　　）。",
            "question": "A．慈善基金\nB．合伙企业\nC．已在中国证券投资基金业协会备案的投资计划\nD．企业年金",
            "answer": "B",
            "explain": "私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：（1）净资产不低于1000万元的单位；（2）金融资产不低于300万元或者最近3年个人年均收入不低于50万元的个人。金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。"
        },
        {
            "title": "以下基金中，不需要披露上市交易公告书的是（　　）。",
            "questions": "I．交易型开放式指数基金、封闭式基金<br>II．分级基金母份额<br>III．交易型开放式指数基金（ETF）联接基金<br>IV．上市开放式基金（LOF）",
            "question": "A．II\nB．II、III\nC．III、IV\nD．I、II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于资产管理行业的特征，以下描述错误的是（　　）。",
            "question": "A．资产管理人根据投资者授权对资产实施管理并承担最终风险\nB．受托资产主要为货币等金融资产\nC．管理方式主要通过投资于证券化的资产\nD．参与方包括委托方和受托方",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "按照不同的交易标的物，金融市场可分为票据市场、证券市场、衍生工具市场、外汇市场、黄金市场等，关于这些市场，以下表述正确的是（　　）。",
            "question": "A．外汇市场指的是外汇批发市场，不包括零售市场\nB．证券市场主要是股票、债券、基金等有价证券发行和转让流通市场。股票市场是有限责任公司的股票发行和转让交易的市场\nC．票据市场是指各种票据进行交易的市场，是资本市场的重要组成部分\nD．衍生工具市场是各种衍生金融工具进行交易的市场，衍生金融工具在金融交易中具有套期保值、防范风险的作用",
            "answer": "D",
            "explain": "按照不同的交易标的物分为票据市场、证券市场、衍生工具市场、外汇市场、黄金市场等。"
        },
        {
            "title": "关于基金的类型，以下表述正确的是（　　）。",
            "question": "A．混合型基金50%的基金资产投资于股票，50%的基金资产投资于债券\nB．债券型基金的基金资产70%以上投资于债券\nC．股票型基金的基金资产只能投资于股票\nD．货币市场基金仅投资于货币市场工具",
            "answer": "D",
            "explain": "根据中国证监会对基金类别的分类标准："
        },
        {
            "title": "关于货币市场基金宣传推介的规定，以下表述正确的包括（　　）。",
            "questions": "I．不得使用与货币市场基金风险收益特征不相匹配的表述<br>II．不得夸大或者片面宣传货币市场基金的投资收益或者过往业绩<br>III．向投资人提供快速赎回等增值服务的，不得披露增值服务的限制条件<br>IV．不得混同、比较货币市场基金与银行存款及其他产品的投资收益",
            "question": "A．II、III、IV\nB．I、II、III\nC．I、II、IV\nD．I、II、III、IV",
            "answer": "C",
            "explain": ""
        }, {
            "title": "基金管理人除依法取得报酬外，应当履行忠实义务，以下选项中，违背了忠实义务的是（　　）。",
            "questions": "I．利用基金财产为自己谋取利益<br>II．将基金财产转为其固有财产<br>III．将因固有财产或者他人财产而同于基金财产从事证券投资<br>IV．公平地对待其管理的不同基金财产",
            "question": "A．II、III、IV\nB．III、IV\nC．I、II\nD．I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "中国证券投资基金业协会是证券投资基金行业的自律组织，下列哪些机构应当入会（　　）。",
            "questions": "I．基金管理人<br>II．基金托管人<br>III．基金服务机构",
            "question": "A．I、II、III\nB．I、III\nC．II、III\nD．I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "基金管理公司在设立子公司时，应当（　　）。",
            "questions": "I．坚持以公募基金为主业<br>II．以专业化、特色化、差异化为原则<br>III．避免母子公司同业竞争<br>IV．母公司应加强对子公司的管控责任",
            "question": "A．II、III\nB．II、III、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于基金职业道德教育，以下表述错误的是（　　）。",
            "question": "A．应当强调基金监管法规是规制不当市场行为的最后屏障\nB．应当引导基金从业人员实行自我监督、自我评价和自我行为调整\nC．应当培养基金从业人员的基金职业道德观念\nD．应当对基金从业人员灌输基金职业道德规范",
            "answer": "A",
            "explain": "基金职业道德还具有基金监管法规不可替代的作用。基金市场的有序运行需要完善的法律制度，但是仅靠刚性的法律制度来约束基金从业人员的行为显然是不够的，难以对千变万化的市场行为进行有效约束，仍会出现一些盲区，这就使得基金从业人员职业道德规范成了规制不当市场行为的最后屏障，而非基金监管法规。"
        },
        {
            "title": "A基金管理公司的研究员甲通过研究公开信息发现，某上市公司即将发布经营业绩优于预期的利好消息，故甲在内部的研究报告中说明重点推荐该上市公司股票进入投资对象备选库。关于上述情况，以下说法错误的是（　　）。",
            "question": "A．甲的研究可以为A公司的投资决策、组合管理等提供研究支持，协助发掘投资机会\nB．甲在研究报告中的投资分析和建议应有充分的事实和数据支持，避免主观臆断\nC．甲的研究报告涉及上市公司的内幕信息，A公司不得将其作为投资依据\nD．A公司应建立投资对象备选库制度，确保各投资组合享有公平的投资决策机会",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "2017年3月1日星期三，某私募基金公司发生有关所管理私募基金投资运作方面的重大事项，按规定需要向中国证券投资基金业协会报告，由于2017年3月国家没有法定假日，该报告的截止日应该为（　　）。",
            "question": "A．2017年3月13日\nB．2017年3月16日\nC．2017年3月15日\nD．2017年3月6日",
            "answer": "C",
            "explain": "私募基金管理人应当根据基金业协会的规定，及时填报并定期更新管理人及其从业人员的有关信息、所管理私募基金的投资运作情况和杠杆运用情况，保证所填报内容真实、准确、完整。发生重大事项的，应当在10个工作日内向基金业协会报告。故本题选C。"
        }, {
            "title": "关于投资者权益保护的手段，以下描述错误的是（　　）。",
            "question": "A．基金公司要开展良好的投资者教育\nB．基金公司要加强公司治理\nC．基金公司要健全投资者适当性制度\nD．基金公司对投资者亏损进行一定补偿",
            "answer": "D",
            "explain": "开展良好的投资者教育、加强公司内部治理结构、健全投资者适当性制度等举措都是投资者权益保护的手段，而对投资者亏损进行补偿这种行为本身就违背了投资风险自负的原则，是错误的。"
        },
        {
            "title": "关于开放式基金的申购和赎回原则，以下表述正确的是（　　）。",
            "question": "A．金额申购、金额赎回\nB．份额申购、金额赎回\nC．份额申购，份额赎回\nD．金额申购、份额赎回",
            "answer": "D",
            "explain": "开放式基金的申赎规则是以金额申购，份额赎回。故本题选D。"
        },
        {
            "title": "关于基金销售机构的职责规范，以下表述错误的是（　　）。",
            "question": "A．基金销售机构应当建立健全档案管理制度，妥善保管基金份额持有人的开户资料和与销售业务有关的其他资料\nB．销售基金时应有合理的业务规则，对基金认购、申购、赎回、转换、非交易过户等行为进行规定\nC．基金募集申请获得中国证监会核准前，基金管理人、基金销售机构可以向公众分发、发布基金宣传推介材料\nD．客户身份资料自业务关系结束当年起至少保存15年，与销售业务有关的其他资料自业务发生当年起至少保存15年",
            "answer": "C",
            "explain": "基金管理人、基金销售机构应当建立健全档案管理制度，妥善管理基金份额持有人的开户资料和与销售业务有关的其他资料。客户身份资料自业务关系结束当年起至少保存15年，与销售业务有关的其他资料自业务发生当年起至少保存15年。"
        },
        {
            "title": "投资者T日赎回1万份某开放式基金，当日基金份额净值为1.5000元，对应的赎回费为0.5%，其可以得到的净赎回金额为（　　）元。",
            "question": "A．14950\nB．14925.37\nC．14975\nD．14925",
            "answer": "D",
            "explain": "本题考查赎回费用的确定。赎回总金额=赎回数量*赎回日基金份额净值=10000*1.5000=15000元，赎回手续费=15000*0.5%=75元，净赎回金额=赎回总额-赎回费用=15000-75=14925元。"
        },
        {
            "title": "关于基金管理人的内部控制监督，以下说法正确的是（　　）。",
            "questions": "I．要建立重大决策负责人独立审批制度，以杜绝负责人推卸责任<br>II．要建立部门之间相互制约的制度，以杜绝部门权力过大或集体徇私舞弊<br>III．要建立关键岗位管理人员轮岗和定期稽查制度，以杜绝中层经理人员以权谋私或串通作案",
            "question": "A．I、II\nB．II、III\nC．I、II、III\nD．I、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于基金公司的宣传推介，以下表述正确的是（　　）。",
            "questions": "I．应加强对投资人的教育和引导<br>II．积极培养投资人长期投资的理念<br>III．注重对行业公信力等的宣传",
            "question": "A．I、II、III\nB．I、III\nC．II、III\nD．I、II",
            "answer": "A",
            "explain": ""
        }, {
            "title": "T日投资者发起申购或赎回我国境内基金，关于基金申购和赎回的资金结算，以下表述错误的是（　　）。",
            "question": "A．申购款一般能在T+2日内到达基金的银行存款账户\nB．基金份额申购和赎回的资金清算是销售机构根据投资者申购和赎回数据进行的\nC．赎回款一般于T+3日内从基金的银行存款账户划出\nD．货币市场基金的赎回资金一般T+1日即可从基金的银行存款账户划出，最快可在划出当天到达投资者资金账户",
            "answer": "B",
            "explain": "基金份额申购和赎回的资金清算是注册登记机构根据确认的投资者申购和赎回数据信息进行的。故“资金清算是销售机构进行的”错误，应是注册登记机构。"
        },
        {
            "title": "确认基金交易是（　　）的职责之一。",
            "question": "A．基金销售机构\nB．中央结算公司\nC．基金份额登记机构\nD．基金托管人",
            "answer": "C",
            "explain": "基金注册登记机构的主要职责：（1）建立并管理投资者基金份额账户；（2）负责基金份额登记，确认基金交易，故“基金份额登记机构”正确；"
        },
        {
            "title": "关于基金销售机构人员的基本行为规范，以下表述错误的是（　　）。",
            "question": "A．基金销售人员向投资者推介基金时应该公平对待投资者\nB．基金销售人员向投资者推介基金时可以帮助投资者下单交易\nC．基金销售人员向投资者推介基金时要征得投资者的同意\nD．基金销售人员向投资者推介基金时首先应进行自我介绍",
            "answer": "B",
            "explain": "基金销售人员禁止性规范中要求，基金销售人员不得违规接受投资者全权委托，直接代理客户进行基金认购、申购、赎回等交易。"
        },
        {
            "title": "QDII基金在其开放申购、赎回前，基金份额净值的披露频率至少为（　　）。",
            "question": "A．每周\nB．每个估值日\nC．每三个月\nD．每月",
            "answer": "A",
            "explain": "QDII基金也是开放式基金，在其开放申购、赎回前，一般至少每周披露一次资产净值和份额净值；开放申购、赎回后，则需要披露"
        },
        {
            "title": "李先生收到一笔10万元的稿酬后，到某银行网点向大堂经理陆经理咨询近期哪些基金表现良好，希望陆经理能为其提供投资建议、推荐基金、办理基金开户，而后决定购买基金。银行大堂经理陆经理在进行产品销售前，先对客户李先生进行风险评估，再根据李先生的投资风险承受能力推荐不同风险等级的产品，符合基金销售（　　）的要求。",
            "question": "A．专业性\nB．适用性\nC．风控性\nD．持续性",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "为向机构客户销售基金，A基金公司拟降低存量公募基金B的销售服务费率，可以通过以下哪种方式实现（　　）。",
            "question": "A．直接免收\nB．先收后返\nC．赠送份额\nD．新设立低费率产品份额",
            "answer": "D",
            "explain": "基金销售机构在基金销售活动中，不得有下列行为：（1）在签订销售协议或销售基金的活动中进行商业贿赂；"
        },
        {
            "title": "关于设立公募基金管理公司，以下符合设立要求的是（　　）。",
            "questions": "I．公司实缴注册资本为2亿元<br>II．公司主要股东最近2年没有违法记录<br>III．公司拟设独立董事3人，占董事会成员人数的1/3<br>IV.公司有正式员工20人，除拟任总经理之外，均取得基金从业资格",
            "question": "A．II、III\nB．I、III\nC．II、IV\nD．I、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "关于混合型基金，以下表述错误的是（　　）。",
            "question": "A．为投资者提供了一种分散投资的工具\nB．混合型基金的预期收益一般高于债券基金\nC．混合型基金的股票配置不得低于80%\nD．混合型基金会根据市场状况对股票和债券的投资比例进行调整",
            "answer": "C",
            "explain": "混合基金属于一种分散投资工具，是为投资者提供了一种在股票、债券等不同资产类别之间进行灵活配置的投资工具，基金管理人对基金投资有比较大的调整自由权限，因此混合型基金的预期收益一般高于债券基金。一般情况下，混合型基金的股票、债券等各种投资资产的配置比例均不会超过80%。"
        },
        {
            "title": "关于私募基金的备案，以下表述错误的是（　　）。",
            "question": "A．经备案的私募基金可以申请开立证券相关账户\nB．私募基金备案材料不完备或者不符合规定的，私募基金管理人应当根据中国证券投资基金业协会的要求及时补正\nC．私募基金管理人应当在私募基金开始募集前，向中国证券投资基金业协会报送基金相关资料\nD．私募基金备案材料包括私募基金的名称、资本规模、投资者等基本信息",
            "answer": "C",
            "explain": "各类私募基金募集完毕，私募基金管理人应当根据基金业协会的规定，办理基金备案手续，故“开始募集前”错误，报送以下基本信息："
        },
        {
            "title": "关于基金销售、销售支付、份额登记等基金服务机构的市场准入监管，以下说法错误的是（　　）。",
            "question": "A．商业银行符合一定条件时，可以向中国证监会申请注册为基金销售机构\nB．从事基金销售、销售支付等相关服务的机构应按照中国证监会规定进行注册或备案\nC．依据《证券投资基金销售管理办法》，基金管理人可以自行办理其募集基金产品的销售业务\nD．中国证监会对公开募集基金的基金份额登记机构实行核准制管理",
            "answer": "D",
            "explain": "中国证监会对从事公开募集基金的销售、销售支付、份额登记、估值、投资顾问、评价、信息技术系统服务等基金服务的机构，实施备案管理，而不是核准制管理。"
        },
        {
            "title": "关于基金管理人的内部控制，表述正确的是（　　）。",
            "questions": "I．管理人开展业务外包应制定相应的风险管理框架及制度<br>II．投资决策应符合合同所约定的预期收益、投资范围、投资策略<br>III．所有基金都应当由基金托管人进行托管<br>IV．基金管理人选择基金服务机构时，应关注该服务机构是否存在与基金服务业务相冲突的其他业务",
            "question": "A．II、IV\nB．I、IV\nC．I、II、IV\nD．II、III",
            "answer": "B",
            "explain": "本题考查基金管理人内部控制的具体内容。"
        },
        {
            "title": "关于基金公司内部控制制度，以下表述错误的是（　　）。",
            "question": "A．内部控制的核心是风险控制\nB．制定内部控制制度应当以审慎经营为出发点\nC．制定内部控制制度应当防范和化解风险为出发点\nD．在风险适度的前提下确保基金管理公司利益最大化",
            "answer": "D",
            "explain": "基金管理人制定内部控制制度一般应当遵循以下原则：1.审慎性原则，公司内部控制制度的核心是风险控制，制定内部控制制度应当以审慎经营、防范和化解风险为出发点。2.全面性原则，内部控制制度应当涵盖公司经营管理的各个环节，不得留有制度上的空白或漏洞。"
        },
        {
            "title": "下列关于道德与法律的调整范围的表述，正确的是（　　）。",
            "question": "A．法律的调整对象侧重于人们的外在行为和言论的合法化\nB．法律可以调整人们内在的精神世界和心理动机\nC．法律的调整对象包括人们的思想和动机\nD．法律调整的范围不如道德调整的范围广",
            "answer": "D",
            "explain": "一般认为，道德调整的范围比法律调整的范围更为广泛。法律调整的对象侧重于人们的外在行为和结果的合法化，具有较强的客观性，人们的思想和动机不是法律调整的对象；而道德不仅要调整人们的外在行为和结果，还要调整人们内在的精神世界和心理动机。"
        }, {
            "title": "关于封闭式基金，以下表述正确的是（　　）。",
            "question": "A．基金份额净值固定不变\nB．基金份额在合同期限内固定不变\nC．基金份额可在基金合同约定的时间和场所进行申购或赎回\nD．基金份额净值与基金二级市场价格一致",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "某资产管理公司拟开展营销活动，销售其管理的私募基金产品，以下行为不合规的是（　　）。",
            "questions": "I．通过与投资者签订《委托投资协议书》的方式，间接向投资金额不足20万元的投资者募集资金<br>II．鼓励员工通过拨打不特定陌生客户电话，推介公司的基金产品<br>III．在其网站上用“使投资利润呈现出最大化的奇迹效应”宣传其投资经理<br>IV．在其网站上设置特定对象确定程序，向已注册的用户定期推送私募基金投资策略报告",
            "question": "A．I、III\nB．I、II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "某基金公司员工甲说：投资者教育的工作形式既可以是现场的报告会、专题讨论会等活动，也可以是非现场的各种宣传形式；员工乙说：教育工作开展形式既可以是报纸、杂志等纸质形式，也可以是依托互联网技术的电子形式。针对甲乙两位员工的说法，下列判断正确的是（　　）。",
            "question": "A．甲的说法正确，乙的说法错误\nB．甲和乙的说法均错误\nC．甲和乙的说法均正确\nD．甲的说法错误，乙的说法正确",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于封闭式基金，以下表述正确的是（　　）。",
            "question": "A．基金份额净值固定不变\nB．基金份额在合同期限内固定不变\nC．基金份额可在基金合同约定的时间和场所进行申购或赎回\nD．基金份额净值与基金二级市场价格一致",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "根据法律形式，可以将证券投资基金分为（　　）。",
            "question": "A．债券型和股票型\nB．主动型和被动型\nC．增值型和收入型\nD．契约型和公司型",
            "answer": "D",
            "explain": "根据法律形式，可以将证券投资基金分为契约型和公司型。根据投资对象将基金分为股票基金、债券基金、货币市场基金、混合基金、基金中基金、另类投资基金等。根据投资理念可以将基金分为主动型基金与被动型（指数）基金。根据投资目标可以将基金分为增长型（成长型）基金、收入型基金和平衡型基金。"
        },
        {
            "title": "根据《证券投资基金法》的规定，以下各项中属于公募证券投资基金的招募说明书必备内容的是（　　）。",
            "question": "A．律师事务所为基金募集出具的法律意见书\nB．基金投资各类证券指令的发送和执行\nC．基金发售机构的名录\nD．基金从事证券交易的清算交收安排",
            "answer": "C",
            "explain": "本题考查的是基金注册的申请。基金招募说明书应当包括下列内容：①基金募集申请的准予注册文件名称和注册日期；②基金管理人、基金托管人的基本情况；③基金合同和基金托管协议的内容摘要；④基金份额的发售日期、价格、费用和期限；⑤基金份额的发售方式、发售机构及登记机构名称；⑥出具法律意见书的律师事务所和审计基金财产的会计师事务所的名称和住所；⑦基金管理人、基金托管人报酬及其他有关费用的提取、支付方式与比例；⑧风险警示内容；⑥中国证监会规定的其他内容。"
        },
        {
            "title": "关于私募基金管理人的登记，以下说法错误的是（　　）。",
            "question": "A．中国证券投资基金业协会对私募基金管理人的信息公示，不代表对其管理的基金资产安全的保证\nB．私募基金管理人登记申请通过中国证券投资基金业协会的在线平台提交，中国证券投资基金业协会只能进行在线核查\nC．中国证券投资基金业协会有权要求私募基金管理人补全私募基金管理人登记材料\nD．私募基金管理人完成登记手续后，仍需定期更新基本信息",
            "answer": "B",
            "explain": ""
        }, {
            "title": "普通投资者陈女士在某银行接受风险承受能力调查，其类别为C4型，她购买了20万元某风险等级为R2级的保本基金，两年后，陈女士风险承受能力显著下降，而该基金产品由于保本周期到期而将变更为R4级混合型基金。以下该银行的做法中，违规的是（　　）。",
            "question": "A．将该基金风险等级变化和陈女士风险承受能力类型变化的情况及时告知陈女士，提醒她重新决策\nB．定期或者不定期提示陈女士重新接受风险承受能力调查，如重新填写风险评估调查问卷等\nC．陈女士不想赎回该保本基金，银行人员指导陈女士重新填写风险评估调查问卷，以达到C4类型\nD．动态跟踪该基金产品，根据基金产品风险等级划分标准，重新评估该基金风险等级",
            "answer": "C",
            "explain": "基金募集机构向投资者销售基金产品或者服务时，禁止出现以下行为：①向不符合准入要求的投资者销售基金产品或者服务；"
        },
        {
            "title": "下列基金公司基金销售活动中不属于直销业务的是（　　）。",
            "question": "A．基金公司自主开发建立电子商务平台\nB．基金公司渠道经理通过商业银行销售基金产品\nC．基金公司销售人员维护机构客户\nD．基金公司销售人员开发高净值个人客户",
            "answer": "B",
            "explain": "基金公司开展直销目前主要包括两种形式，其一是专门的销售人员直接开发和维护机构客户和高净值个人客户，其二是自行开发建立电子商务平台。代销机构是指与基金公司签订基金产品代销协议，代为销售基金产品，赚取销售佣金的商业机构，主要包括商业银行、证券公司、期货公司、保险机构、证券投资咨询机构以及独立基金销售机构。"
        },
        {
            "title": "基金销售合规性风险管理的主要措施包括（　　）。",
            "questions": "I．对宣传推介材料进行合规审查<br>II．严格选择合作的销售机构<br>III．制定符合投资适当性法规要求的政策措施<br>IV.制定适当的销售政策和监督措施",
            "question": "A．I\nB．I、II、III\nC．I、II、III、IV\nD．I、II",
            "answer": "C",
            "explain": "根据《基金管理公司风险管理指引（试行）》等规定，销售合规性风险管理主要措施包括："
        },
        {
            "title": "关于公司督察长和内部监察稽核部门，以下表述错误的是（　　）。",
            "question": "A．公司监察稽核部负责对内部控制制度的执行情况进行持续的监督\nB．公司监察稽核部负责对公司内部控制制度的执行情况实行严格检查和反馈\nC．公司监察稽核部门独立于其他部门\nD．公司督察长的职责由总经理确定",
            "answer": "D",
            "explain": "基金管理人应当设立督察长，对董事会负责，经董事会聘任，报中国证监会核准。"
        },
        {
            "title": "关于基金招募说明书中的风险提示，以下表述错误的是（　　）。",
            "question": "A．应该在招募说明书的正文，就基金投资于融资融券的风险因素进行分析\nB．应该在招募说明书的正文，列明与特定基金品种相关的特定风险\nC．可以在招募说明书最后的页脚不显著位置，做出“不保证基金一定盈利”的表述\nD．可以在招募说明书封面的显著位置，做出“基金过往业绩不预示未来表现”的表述",
            "answer": "C",
            "explain": "在招募说明书封面的显著位置，管理人一般会做出“基金过往业绩不预示未来表现；不保证基金一定盈利，也不保证最低收益”等风险提示，“不显著位置”说法错误。在招募说明书正文，管理人还会就基金产品的各项风险因素进行分析，并列明与特定基金品种、特定投资方法或特定投资对象相关的特定风险。只有对投资基金的相关风险有清醒的认识，投资者才能做出科学的选择，才能放心地将资金交给管理人管理。即便是基金运作中出现亏损，投资者也能理解和接受。对于基金管理人来说，风险的充分揭示可以保证资金来源的稳定，从而为基金"
        },
        {
            "title": "张某拟投资上市开放型基金（LOF），关于其可以采取的交易方式，以下说法正确的包括（　　）。",
            "questions": "I．在代销该基金的银行申购该基金<br>II．在银行申购的基金份额只能在银行赎回<br>III．在证券交易所买进该基金，并只能在证券交易所卖出<br>IV.在银行申购该基金转托管到证券交易所卖出",
            "question": "A．I、III\nB．III、IV\nC．II、III\nD．I、IV",
            "answer": "D",
            "explain": ""
        }, {
            "title": "某基金公司董事会人数为5人，则该公司独立董事应不少于（　　）人。",
            "question": "A．1\nB．3\nC．4\nD．2",
            "answer": "B",
            "explain": "根据相关法律法规，独立董事人数不得少于3人，且不得少于董事会人数的1/3。"
        },
        {
            "title": "根据相关法律法规规定，以下可以从事募集私募基金活动的机构包括（　　）。",
            "questions": "I．已在中国证券投资基金业协会办理登记的私募基金管理人<br>II．在中国证监会注册取得基金销售业务资格并已成为中国证券投资基金业协会会员的机构<br>III．在中国证监会注册取得基金托管业务资格并已成为中国证券投资基金业协会会员的机构",
            "question": "A．I、II\nB．II、III\nC．I、II、III\nD．I、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某上市公司的实际控制人因刑事犯罪被司法机关逮捕后，该上市公司股票连续多个交易日跌停，某基金管理人对旗下公募基金持有的该上市公司股票采用当日收盘价格进行估值。以下表述正确的是（　　）。",
            "question": "A．基金管理人应当建立会计复核制度，防止会计差错发生\nB．基金管理人应当规范基金清算交割工作，确保基金资产安全\nC．基金管理人应当保证同一基金的不同份额之间独立建账和独立核算\nD．基金管理人应当采取合理的估值方法和科学的估值程序",
            "answer": "D",
            "explain": "基金管理人应当采取适当的会计控制措施，以确保会计核算系统的正常运转：(1)应当建立凭证制度，通过凭证设计、登录、传递、归档等一系列凭证管理制度，确保正确记载经济业务，明确经济责任；(2)应当建立账务组织和账务处理体系，正确设置会计账簿，有效控制会计记账程序；(3)应当建立复核制度，通过会计复核和业务复核防止会计差错的产生；(4)应当采取合理的估值方法和科学的估值程序，公允反映基金所投资的有价证券在估值时点的价值。故“采用当日收盘价格进行估值”错误。"
        },
        {
            "title": "关于基金从业人员“专业审慎”的职业道德要求，以下表述错误的是（）。",
            "question": "A．持证上岗\nB．持续学习\nC．审慎开展执业活动\nD．大客户利益最大化",
            "answer": "D",
            "explain": "专业审慎对于基金从业人员的基本要求体现在三个方面：持证上岗、持续学习、审慎开展执业活动，故“大客户利益最大化”错误。"
        },
        {
            "title": "根据《公开募集证券投资基金法》关于公募证券投资基金募集的规定，以下符合法律规定的是（）。",
            "question": "A．某证券投资基金募集期限届满未完成，其后第50天，基金管理人向投资人返还了全部已交纳的款项并加计银行同期存款利息\nB．某封闭式公司证券投资基金募集期限届满，募集的基金份额总额为发行注册规模的65%，基金管理人宣布募集失败\nC．某证券投资基金募集完毕，发布基金合同生效公告后，进行验资\nD．某公司证券投资基金募集过程中，管理人为提高资金收益而将募集资金投资于理财产品",
            "answer": "B",
            "explain": "基金募集期限届满，封闭式基金募集的基金份额总额未达到准予注册规模的80%以上，不能满足法律规定的条件，无法办理基金备案手续，基金合同不生效，也即基金募集失败。"
        },
        {
            "title": "基金托管人发现基金管理人的投资指令违反基金法规时，正确的做法是（）。",
            "question": "A．应报告中国证监会并按要求处理\nB．应在执行投资指令后立即报告中国证监会\nC．应当拒绝执行，立即通知基金管理人，并及时向中国证监会报告\nD．应通知管理人后再执行投资指令",
            "answer": "C",
            "explain": "基金托管人发现基金管理人的投资指令违反法律、行政法规和其他有关规定，或者违反基金合同约定的，应当拒绝执行，立即通知基金管理人，并及时向中国证监会报告。"
        },

        {
            "title": "下列不属于基金信息披露内容的是（　　）。",
            "question": "A．披露基金份额净值\nB．披露基金每周投资持仓\nC．披露基金资产净值\nD．公告基金募集情况",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金合同生效10年以上的基金，宣传推介材料应当符合以下要求（　　）。",
            "question": "A．应当登载最近2个完整会计年度的业绩\nB．应当登载最近5个完整会计年度的业绩\nC．应当登载最近8个完整会计年度的业绩\nD．应当登载最近10个完整会计年度的业绩",
            "answer": "D",
            "explain": "基金宣传推介材料登载过往业绩的，应当符合以下要求：(1)基金合同生效6个月以上但不满1年的，应当登载从合同生效之日起计算的业绩。(2)基金合同生效1年以上但不满10年的，应当登载自合同生效当年开始所有完整会计年度的业绩，宣传推介材料公布日在下半年的，还应当登载当年上半年度的业绩。"
        },
        {
            "title": "沪、深证券投资基金账户不能参与的投资为（　　）。",
            "question": "A．ETF基金证券认购\nB．封闭式基金(网上发售)认购\nC．ETF基金场内现金认购\nD．证券公司代销的开放式基金认购",
            "answer": "A",
            "explain": "(1)ETF认购：投资者进行现金认购时需具有沪、深A股证券账户或证券投资基金账户。投资者进行证券认购应开立沪、深证券账户。沪、深证券投资基金账户只能进行基金的现金认购和二级市场交易，不能参与证券认购或基金的申购、赎回。投资者进行证券认购时需具有沪、深A股证券账户。故沪、深证券投资基金账户不可以参与“ETF基金证券认购”，故选该项。"
        },
        {
            "title": "基金管理人（　　）负责设定公司的合规管理目标，审核、监督公司风险控制制度的有效执行，对合规管理的有效性承担责任。",
            "question": "A．董事会\nB．督察长\nC．监事会\nD．管理层",
            "answer": "A",
            "explain": "基金管理人董事会设定公司的合规管理目标，审核、监督公司风险控制制度的有效执行，对合规管理的有效性承担责任，故“董事会”正确。"
        },
        {
            "title": "关于基金当事人及服务机构的职责，以下表述错误的是（　　）。",
            "question": "A．份额登记机构的主要职责是基金份额的登记过户、存管和结算\nB．基金估值机构的主要职责是基金结算的信息披露\nC．基金管理人主要负责基金产品的募集和管理\nD．基金托管人的主要职责是资产保管、基金资金清算",
            "answer": "B",
            "explain": "基金估值机构是指执行基金会计核算、估值及相关信息披露等业务活动的机构，“结算信息披露”表述错误。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/flfg-1.js